import { IS_DTF_USER_RETENTION_MODAL_SHOWN } from "./constants";

export const REDRAW_NOTES_TEXT_AREA = "custom-notes-textarea";

export const setDtfUserRetentionModalShown = () => {
  sessionStorage.setItem(IS_DTF_USER_RETENTION_MODAL_SHOWN, "true");
};

export const isDtfUserRetentionModalShown = () => {
  const value = sessionStorage.getItem(IS_DTF_USER_RETENTION_MODAL_SHOWN);
  return value === "true";
};

export const scrollToTextAreaAndHighlight = (textareaIdx = 0) => {
  const $redrawNotesTextareas = document.querySelectorAll(
    `[data-redraw-text-area-identifier="${REDRAW_NOTES_TEXT_AREA}"]`
  );
  const $redrawNotesTextarea = $redrawNotesTextareas[textareaIdx];
  if ($redrawNotesTextarea) {
    $redrawNotesTextarea.scrollIntoView({ behavior: "smooth", block: "center" });
    $redrawNotesTextarea.classList.add("custom-notes__textarea--highlighted");
  }
};
